




















































import { Component, Provide, Vue } from 'vue-property-decorator'
import { PrintableDocument } from '@/api/model/printable-document'
import { PrintableDocumentAPI } from '@/api/backend-client'
import ListActions from '@/views/Company/Settings/EmmaDirectMail/PrintableDocuments/ListActions.vue'

@Component({
    components: { ListActions },
})
export default class CompanySettingsEmmaDirectMailPrintableDocumentsList extends Vue {
    loading: boolean = false
    printableDocuments: PrintableDocument[] = []

    async created(): Promise<void> {
        await this.reload()
    }

    @Provide()
    async reload(): Promise<void> {
        this.loading = true
        this.printableDocuments = await PrintableDocumentAPI.getAll({ company: this.$currentCompany.id })
        this.loading = false
    }

    async goToCreate(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_emma_direct_mail_printable_documents_create',
        })
    }
}
